var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 120,
    viewBox: "0 0 400 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neonBlue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metallic",
    gradientTransform: "rotate(65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "modernGlow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0                 0 1 0 0 0                 0 0 1 0 0                 0 0 0 15 -7"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "diagonalHatch",
    width: 10,
    height: 10,
    patternTransform: "rotate(45)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -40) rotate(-30) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 L60,10 L40,20 L40,0Z",
    fill: "url(#metallic)",
    filter: "url(#modernGlow)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 40,
    height: 4,
    rx: 2,
    fill: "url(#neonBlue)",
    filter: "url(#modernGlow)"
  })), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 0,
    fontFamily: "'Orbitron', sans-serif",
    fontSize: 72,
    fontWeight: 700,
    letterSpacing: 4,
    fill: "url(#neonBlue)",
    filter: "url(#modernGlow)"
  }, "\n      MINE\n    "), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 0,
    fontFamily: "'Orbitron', sans-serif",
    fontSize: 72,
    fontWeight: 900,
    fill: "white",
    filter: "url(#modernGlow)"
  }, "\n      IT\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(340, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,-10 L20,0 L10,10 Z",
    fill: "url(#neonBlue)",
    filter: "url(#modernGlow)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "2s",
    repeatCount: "indefinite"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#diagonalHatch)",
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9921c3898d5fe3ef362b3b223096caf2.svg";
export { ForwardRef as ReactComponent };